import React, {PropTypes} from "react";
import {DropdownButton, MenuItem as MenuItems, Button} from "react-bootstrap";
import AutoComplete from "material-ui/AutoComplete";
import MenuItem from "material-ui/MenuItem";
import DisplayTable from "../common/DisplayTable";
import Dialog from "material-ui/Dialog";
import {hashHistory} from "react-router";
import Toggle from "material-ui/Toggle";
import axios from "axios";


class TopHeader extends React.Component {

  constructor() {
    super();
    this.state = {data: null, show: false, index: -2, employees: [], email: false, hintText: "", empId : null}
    this.log = this.log.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {

  }

  componentWillReceiveProps(props) {
    if (props.employees.length != this.state.employees.length) {
      this.setState({employees: props.employees})
    }
  }

  close() {
    this.setState({show: false, hintText: ""})
  }

  log(e) {

  }

  render() {
    let menu = Object.assign([], this.state.employees);
    if (!this.state.email) {
      menu.sort((a, b)=> {
        return parseInt(a.employeeCode) - parseInt(b.employeeCode);
      });
      menu = menu.map((node)=> {
        return {
          text: node.employeeCode + " " + node.name + " (" + node.emailId + ")",
          value: (<MenuItem
              style={{padding: 0, margin: 0, color: 'black', fontSize: '14'}}
              listStyle={{padding: 0, height: '5px', margin: 0}}
              primaryText={node.employeeCode + " - " + node.name}
              secondaryText={<a>{node.emailId}</a>}
            />
          ),
        }
      });
    }
    const dataSource1 = menu;

    const actions = [
      <Button

        style={{marginRight: '5%'}}
        backgroundColor={'#428BCA'}
        onTouchTap={()=> {

          this.close();
          hashHistory.push('/1/profile/' + this.state.data.employeeCode)

        }
        }
      >View More</Button>,
      <Button

        style={{marginRight: '40%'}}
        backgroundColor={'#428BCA'}
        onTouchTap={()=> {


          this.close();
        }
        }
      >Go Back</Button>
    ];
    let name = "";
    if (this.state.data != null) {
      name = this.state.data.employeeCode.toString() + " " + this.state.data.name;
    }
    return (
      <div>
        <nav className="navbar navbar-default">
          <div className="container-fluid">
            <div className="navbar-header">
              <button type="button" className="navbar-toggle"
                      onClick={ this.props.handleToggle}><span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span> <span className="icon-bar"></span> <span className="icon-bar"></span>
              </button>
              <a className="navbar-brand" href="#/1/home"><img src="/public/images/logo.png"
                                                               alt="Quikr - Asaan hai Badalna" width="94" height="43"/></a>
            </div>
            <div className="collapse navbar-collapse top-right">
              <ul className="nav navbar-nav navbar-right search">
                <div id="toprightrec">
                  <div className="nav navbar-nav navbar-right search">
                    <li className="dropdown">
                      <div id="asss" style={{paddingLeft: 0, marginLeft: 20}}>
                                          <span style={{marginRight: '20px'}} onClick={()=> {
                                            this.setState({show: true})
                                          }} className="glyphicon glyphicon-search hand"></span>
                        <DropdownButton className="dropdown-menu-right" id="1" title={this.props.name}>
                          <MenuItems eventKey="2" onClick={()=> {
                            hashHistory.push("/1/myProfile")
                          }}>My Profile</MenuItems>

                          <MenuItems eventKey="3" onClick={()=> {
                            hashHistory.push("/1/myReporting")
                          }}>My Reporting</MenuItems>
                          <hr style={{margin: 5}}/>
                          <MenuItems eventKey="4" onClick={this.props.logout}>Logout</MenuItems>
                        </DropdownButton></div>
                    </li>
                  </div>
                </div>
              </ul>

              <div className="navbar-form navbar-right" role="search" style={{
                marginBottom: 0,
                marginTop: 10, paddingRight: 0, width: '500px'
              }}>
                <div className="input-group testing" style={{width: '500px'}}>
                  <div style={{display: 'none'}}>
                    <Toggle
                      style={{width: '60px'}}
                      toggled={this.state.email}
                      onToggle={()=> {
                        if (this.state.email)
                          this.setState({hintText: "Search by Id and Name", email: !this.state.email})
                        else this.setState({hintText: "Search by Id and EmailId", email: !this.state.email})

                      }}
                    /></div>
                  <div style={{display: 'inline-block', width: '500px', marginRight: 10}}>
                    <AutoComplete
                      onUpdateInput={(text)=> {
                        this.setState({hintText: text})
                      }}
                      searchText={this.state.hintText}
                      menuStyle={{padding: 0, margin: 0, fontSize: 10}}
                      listStyle={{padding: 0, margin: 0, fontSize: 10}}
                      style={{marginRight: 10, display: 'inline'}}
                      fullWidth={true}
                      onNewRequest={(chosenRequest, index)=> {
                        let flag = window.location.hash.split('?')[0].split('/')[2];
                        if (index == -1 && this.state.data != null) {
                          this.setState({show: true});
                          return;
                        }
                        this.setState({empId: chosenRequest.text.split(' ')[0]});
                        axios.get(process.env.REQ_URL + "/aboutEmp?q=" + chosenRequest.text.split(' ')[0], {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                          this.setState({data: response.data.data, index: index, show: true})
                        }).catch((error) => {

                        });
                      }}
                      onKeyDown={(e)=> {
                        if (e.target.value.length == 0) {
                          this.setState({index: -2})
                        }
                      }}
                      errorText={this.state.error}
                      hintText="Search for Employee by Id, Name or Email"
                      maxSearchResults={15}
                      filter={AutoComplete.caseInsensitiveFilter}
                      dataSource={dataSource1}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>

        {this.state.index != -2 ?

          <Dialog
            contentStyle={{width: '90%', maxWidth: 'none'}}
            autoScrollBodyContent={true}

            autoDetectWindowHeight={true}
            title={name}
            actions={actions}
            modal={false}
            open={this.state.show}
            onRequestClose={this.close}
          >
            <DisplayTable empNo={this.state.empId} data={this.state.data} title="Public Info" height="250px" width="250px"/>
          </Dialog>
          : null}
      </div>);
  }
}


export default TopHeader;





/** WEBPACK FOOTER **
 ** ./src/components/TopNavigation/TopHeader.js
 **/